import React from 'react';
import { VipTierUpgradeModal } from './VipTierUpgradeModal';
import { useVip } from '@/contexts/VipContext';
import { useIsBrowserPromptActive } from '@/stores/browserPromptStore';

export const GlobalVipTierUpgradeModal = () => {
  // Hooks must be called unconditionally - ErrorBoundary will catch any errors
  // useVip now returns safe defaults instead of throwing, so this is safe
  const vipContext = useVip();
  const isBrowserPromptActive = useIsBrowserPromptActive();
  const tierUpgrade = vipContext?.tierUpgrade || null;
  const clearTierUpgrade = vipContext?.clearTierUpgrade || (() => {});
  const refreshVipData = vipContext?.refreshVipData || (async () => {});

  // Wait for any browser permission prompt to be dismissed first - the upgrade stays
  // in VipContext, so the modal shows as soon as the prompt is done
  if (isBrowserPromptActive) {
    return null;
  }

  // Validate tierUpgrade before passing to modal - return null if invalid
  if (!tierUpgrade) {
    return null;
  }

  if (!tierUpgrade.oldTier || !tierUpgrade.newTier) {
    return null;
  }

  // Additional validation - ensure all required properties exist
  if (!tierUpgrade.oldTier.id || !tierUpgrade.newTier.id) {
    return null;
  }

  if (!tierUpgrade.oldTier.tier_name || !tierUpgrade.newTier.tier_name) {
    return null;
  }

  const handleClose = () => {
    try {
      if (clearTierUpgrade) {
        clearTierUpgrade();
      }
      // Refresh VIP data to ensure rewards are up to date
      setTimeout(() => {
        try {
          if (refreshVipData) {
            refreshVipData();
          }
        } catch (refreshError) {
          console.error('Error refreshing VIP data on modal close:', refreshError);
          // Silently fail - don't break the app
        }
      }, 100);
    } catch (closeError) {
      console.error('Error closing VIP tier upgrade modal:', closeError);
      // Silently fail - don't break the app
    }
  };

  return (
    <VipTierUpgradeModal 
      upgrade={tierUpgrade}
      onClose={handleClose}
    />
  );
};

